import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { event } from 'jquery';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererNewCilDasboard',
  template: `
    <button tooltipPosition="top"  pTooltip="View Responsible"
      mat-mini-fab
      color="accent"
      (click)="onClick($event)"
    >
      <mat-icon>remove_red_eye </mat-icon>
    </button>
  `,
  styles: [
    `
      .add-icon {
        background: cornflowerblue;
      }
      button{
        height: 35px;
        width: 35px;
        display: inline-flex;
    align-items: center;
    justify-content: center;
        margin: 0 3px;

      }
      .mat-icon {
        transform: scale(0.7);
      }
    `,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererNewCilDashBoard
  implements ICellRendererAngularComp, OnDestroy {
  clicked = false;
  params: any;
  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }
  agInit(params: any): void {
    this.params = params;
  }
  
  onClick($event: any): any {
    if (this.params.onClick instanceof Function) {
        // put anything into params u want pass into parents component
        const params = {
            event: $event,
            rowData: this.params.node.data,
            // ...something
        };
        this.params.onClick(params);
    }
}

  
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
